// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/air-composition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/air-composition/air-composition.js';

mount([g0]);
